import { useOktaAuth } from '@okta/okta-react';
import { PageLoader } from '@optools/components/loading/page-loader';
import { useOktaProfile } from '@optools/hooks/useOktaProfile';

export function ProfileProvider({ children }: { children: React.ReactNode }) {
  const { isLoading, isUninitialized } = useOktaProfile();
  const { authState, oktaAuth } = useOktaAuth();

  if (oktaAuth.isLoginRedirect()) return children;

  if (!authState || (authState?.isAuthenticated && isUninitialized) || isLoading) {
    return <PageLoader />;
  }

  return children;
}
